import type { SVGProps } from "react";
export interface FishBoneIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FishBoneIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FishBoneIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.705 5.705a1.125 1.125 0 0 1 1.505-.078l.086.078 2.703 2.704 2.206-2.205a1.125 1.125 0 0 1 1.59 1.59L15.59 10l2.706 2.706.078.085a1.125 1.125 0 0 1-1.582 1.582l-.087-.076L14 11.59 12.589 13l1.707 1.705.076.085a1.125 1.125 0 0 1-1.582 1.583l-.085-.078L11 14.59l-2.204 2.205a1.125 1.125 0 1 1-1.59-1.59l2.203-2.206-1.704-1.703-.076-.087A1.124 1.124 0 0 1 9.21 9.627l.085.078 1.704 1.704 1.409-1.41-2.703-2.704-.077-.085a1.125 1.125 0 0 1 .077-1.505"
      />
      <path
        fill={color}
        d="M1.673 14.14c2.231-.679 3.976-.476 5.198-.05a6 6 0 0 1 1.382.683 5 5 0 0 1 .485.377l.036.032.011.013.006.005.003.003v.001l-.712.713c.713-.713.715-.711.715-.711l.009.008.011.013.034.036a5 5 0 0 1 .375.483c.215.32.474.781.684 1.384.426 1.222.63 2.966-.048 5.198a1.126 1.126 0 0 1-1.655.637c-1.664-.998-2.462-2.285-2.822-3.365a5.5 5.5 0 0 1-.197-.788 5.5 5.5 0 0 1-.787-.198c-1.08-.36-2.368-1.156-3.366-2.82a1.127 1.127 0 0 1 .638-1.655Zm2.454 1.819c.353.263.693.423.986.52.318.107.592.145.78.158q.14.007.201.004l.03-.001H6.12a1.127 1.127 0 0 1 1.237 1.242l.002-.003-.002.028c0 .04-.001.11.005.202.012.187.05.461.157.78.097.291.258.63.521.982.048-.855-.087-1.52-.255-2a3.8 3.8 0 0 0-.425-.867 2 2 0 0 0-.14-.189l-.015-.016-.022-.02a2 2 0 0 0-.187-.14 3.8 3.8 0 0 0-.868-.424c-.481-.168-1.146-.304-2.002-.256ZM19.624.884a3.6 3.6 0 0 1 3.493 3.492c.06 1.975-.206 3.796-.742 5.426-.514 1.558-2.395 1.77-3.402.763l-5.537-5.539c-1.006-1.006-.796-2.886.762-3.4l.62-.189c1.467-.41 3.077-.605 4.806-.553m-.068 2.248c-1.586-.048-3.028.146-4.308.525l5.093 5.094c.379-1.28.574-2.72.526-4.306a1.35 1.35 0 0 0-1.31-1.313Z"
      />
    </svg>
  );
}
